import { render, staticRenderFns } from "./Studio.vue?vue&type=template&id=086a4d26"
import script from "./Studio.vue?vue&type=script&lang=js"
export * from "./Studio.vue?vue&type=script&lang=js"
import style0 from "./Studio.vue?vue&type=style&index=0&id=086a4d26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports